<template>
    <el-dialog title="详情"
               :visible.sync="show"
               width="30%"
               :before-close="closePopup"
               class="showDetail">

        <el-form>
            <!-- 你好 -->
            <el-form-item label="头像:">
                <el-image v-if="db.avatar" :src="baseUrl + 'stage-api' + db.avatar"
                          fit="cover"
                          alt="" />
				<img v-else src="@/assets/default_avatar.png"
				style="width:100px"
                          fit="cover"
                          alt="" />		  
            </el-form-item>

            <el-form-item label="师种:">缩水师</el-form-item>
            <el-form-item label="昵称:">{{db.nickName}}</el-form-item>
            <el-form-item label="期号:">{{db.number}}</el-form-item>
            <el-form-item label="指标:">{{db.preIndexLabel}}注</el-form-item>
            <el-form-item label="准确率:">{{db.back_number}}期中{{db.correct_num}}</el-form-item>
            <el-form-item label="价格:">
				<span v-if="db.coin == 0"> {{db.coin}}缩币 </span>
				<span v-else> {{db.coin}} 缩币</span>
			</el-form-item>
            <el-form-item label="是否中奖:" >
				<span v-if="db.is_win == 2"> 否 </span>
				<span v-if="db.is_win == 1"> 是 </span>
				<span v-if="db.is_win == 0"> -- </span>
			</el-form-item>

        </el-form>

    </el-dialog>
</template>

<script>
export default {
    name: 'showDetail',
    data () {
        return {
            show: false,
            db: {},
			baseUrl: process.env.VUE_APP_BASE_API,
        }
    },
    methods: {
        init (item, preIndexLabel, type) {
			this.db = {}
            console.log('init - item', JSON.parse(JSON.stringify(item)));
            console.log('init - type', type);
            console.log('init - preIndexLabel', preIndexLabel);
            this.show = true

            // item.preIndexLabel = preIndexLabel
            item.preIndexLabel = JSON.parse(item[type]).real_bet_number
            item.type = type
            item.back_number = JSON.parse(item[type]).back_number
            item.correct_num = JSON.parse(item[type]).correct_num
            item.coin = JSON.parse(item[type]).coin
            item.is_win = JSON.parse(item[type]).is_win

            this.db = item

			console.log('db', JSON.parse(JSON.stringify(this.db)));

        },
        closePopup () {
            this.show = false;
            this.db = {};
        }
    }
}
</script>

<style lang="scss" scoped>
.el-form-item{
	margin-bottom: 0;
}
.el-image {
    width: 80px;
    height: 80px;
    border-radius: 50%;
}
</style>